module.exports = __webpack_public_path__ + "static/media/cv-joints-and-cv-axles.364103db.svg";